import Phaser from "phaser";
import { FishBase } from "./FishBase";

export class WalleyeAI extends FishBase {
    private heading = Phaser.Math.FloatBetween(0, Math.PI * 2);
    private turnAt = 0;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, {
            species: "Walleye",
            textureKey: "walleye",
            pointValue: 25,
            swimSpeed: 115,
        });
    }

    override update(time: number): void {
        if (time > this.turnAt) {
            this.heading += Phaser.Math.DegToRad(Phaser.Math.Between(-45, 45));
            this.turnAt = time + Phaser.Math.Between(1400, 2600);
        }
        const vx = Math.cos(this.heading) * this.swimSpeed;
        const vy = Math.sin(this.heading) * this.swimSpeed;
        this.swimWithBias(vx, vy);
        this.heading = this.rotation;
    }
}
